// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/global.scss
// module id = 14
// module chunks = 0